import { render, staticRenderFns } from "./LocationNew.vue?vue&type=template&id=330b8e13&scoped=true&"
import script from "./LocationNew.vue?vue&type=script&lang=js&"
export * from "./LocationNew.vue?vue&type=script&lang=js&"
import style0 from "./LocationNew.vue?vue&type=style&index=0&id=330b8e13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330b8e13",
  null
  
)

export default component.exports